import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Checkbox, FormControlLabel } from '@mui/material';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import { CollapseCard } from '@totalsoft/rocket-ui';
import { get } from '@totalsoft/change-tracking-react';
import { onCheckBoxChange } from 'utils/propertyChangeAdapters';
import { useTranslation } from 'react-i18next';

const RisksComponent = ({ risks, onPropertyChange, cardIconColor, disabled }) => {
  const { t } = useTranslation();
  return (
    <CollapseCard
      iconColor={cardIconColor}
      icon={PlaylistAddCheckIcon}
      title={t('Offer.Edit.Casco.Risks.Title')}
      sx={{ mb: 1 }}
      toggleOnHeaderClick
    >
      <Grid container>
        {risks.length > 0 ? (
          risks.map((risk, index) => (
            <Grid item xs={12} key={index}>
              <FormControlLabel
                disabled={(risk.readOnly |> get) || (risk.mandatory |> get) || disabled}
                control={
                  <Checkbox
                    id={'Risk_' + index}
                    checked={Boolean(risk.selected |> get)}
                    onChange={onCheckBoxChange(onPropertyChange(risk.quotationRiskId |> get))}
                  />
                }
                label={risk.riskName |> get}
              />
            </Grid>
          ))
        ) : (
          <Grid container justifyContent='center'>
            {t('Offer.Edit.Casco.Risks.EmptyList')}
          </Grid>
        )}
      </Grid>
    </CollapseCard>
  );
};

RisksComponent.propTypes = {
  risks: PropTypes.array,
  onPropertyChange: PropTypes.func,
  cardIconColor: PropTypes.string,
  disabled: PropTypes.bool
};

export default RisksComponent;
